import { v4 } from 'uuid';
import { create } from 'zustand';

/*
 * TODOs:
 * - Improve typing to restrict a payload based on his 'modal type'
 * - value using js Symbol in the `modal type` to allow possibles value collisions
 * - Improve the automatic registering of `Generic Modals` to avoid including modals not needed
 *  by the consumer (optional registering + lazy loading)
 * */

// ! Store
const createModalStore = () => create(set => ({
  // state
  metaModals: [],
  registry: {},
  // methods
  registerModals: modals => set(state => ({
    registry: {
      ...state.registry,
      ...modals
    }
  })),
  openModal: metaModal => {
    const modalKey = v4();
    set(state => ({
      metaModals: [...state.metaModals, {
        ...metaModal,
        key: modalKey
      }]
    }));
    return modalKey;
  },
  updateModal: (key, payload, options) => {
    set(state => ({
      metaModals: state.metaModals.map(modal => {
        if (modal.key !== key) return modal;
        if (options?.merge) {
          return {
            ...modal,
            payload: {
              ...modal.payload,
              ...payload
            }
          };
        }
        return {
          ...modal,
          payload
        };
      })
    }));
  },
  closeModal: key => set(state => ({
    metaModals: state.metaModals.filter(modal => modal.key !== key)
  }))
}));
var createModalStore$1 = createModalStore;

export { createModalStore$1 as default };
//# sourceMappingURL=modalStore.js.map
